import { getCurrentLanguage, hasLanguage } from '../../../../../helpers/LangHelper';
import { ISideNavigationMenuItemsConfig } from '../SideNavigationMenuConfiguration';

export const isEmptyList = (list: any[] | undefined) => !list || list.length === 0;

export const getCurrentPath = () => {
    let delimiter = `/`;

    if (hasLanguage()) {
        const lang = getCurrentLanguage();
        delimiter = `${delimiter}${lang}${delimiter}`;
    }

    return window.location.href.replace(`${window.location.origin}${delimiter}`, '');
};

export const isEmptyPath = (path: string) => !path || path.length === 0;

export const isDefaultRoute = (
    item: ISideNavigationMenuItemsConfig,
    currentSelection: ISideNavigationMenuItemsConfig | null
): boolean => (item.default && currentSelection === null) || false;
